import React from 'react'

const Social = () => {
    return (
        <div>
            <div className="home__social">
                <a href="https://www.linkedin.com/in/vrushal-shahare/" className="home__social-icon" target="_blank">
                    <i className="bx bxl-linkedin"></i>
                </a>
                <a href="https://vrushalportfolio.netlify.app/" className="home__social-icon" target="_blank">
                    <i className="uil uil-user-circle"></i>
                </a>
                <a href="https://github.com/Vrushal143" className="home__social-icon" target="_blank">
                    <i className="uil uil-github-alt"></i>
                </a>
            </div>
        </div>

    )
}

export default Social
